/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductSwiper_item = {
    readonly carouselPhotos: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"ThumbImage_photo">;
    } | null> | null;
    readonly " $refType": "ProductSwiper_item";
};
export type ProductSwiper_item$data = ProductSwiper_item;
export type ProductSwiper_item$key = {
    readonly " $data"?: ProductSwiper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProductSwiper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "photosLimit",
      "type": "Int",
      "defaultValue": 3
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "carouselPhotos",
      "name": "photos",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ThumbImage_photo",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '68406aa4b45fd58003630d3d8541f235';
export default node;
